import styled from 'styled-components';

export const Circle = styled.span` width: 35px; 
                            height: 35px; 
                            line-height: 35px; 
                            border-radius: 50%; 
                            -moz-border-radius: 50%; 
                            -webkit-border-radius: 50%; 
                            text-align: center; 
                            color: white; 
                            font-size: 16px; 
                            text-transform: uppercase; 
                            font-weight: 500; 
                            margin: 0 auto; 
                            background-color: #768798;
                            margin-left: 1rem;
                            display: inline-block;`;
